import { createSelector } from 'reselect'
import { AppStateType } from '../reducers'
import { IFile } from '../types/file'

export const selectFile = ({ file }: AppStateType): IFile => file

export const selectFileInstance = createSelector(
  selectFile,
  ({ fileInstance }) => fileInstance
)

export const selectUploadURI = createSelector(
  selectFile,
  ({ uploadURI }) => uploadURI
)

export const selectFileName = createSelector(
  selectFile,
  ({ name, extension }) => `${name}.${extension}`
)

export const selectFileExtension = createSelector(
  selectFile,
  ({ extension }) => extension
)

export const selectFileId = createSelector(selectFile, ({ id }) => id)

export const selectExistingEdition = createSelector(
  selectFile,
  ({ existingEdition }) => existingEdition
)

export const selectEditionsToUpdate = createSelector(
  selectFile,
  ({ editionsToUpdate }) => editionsToUpdate
)
